import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";
import { REGISTRATION_EXPIRY_SEARCH_COLUMNS } from "./consts";
import { RegistrationSearchResultsProps } from "./types";

const RegistrationSearchResults: React.FC<RegistrationSearchResultsProps> = (
  props
) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onPaginationChange,
    onSelectedChange,
    onVehicleClick,
  } = props;

  return (
    <TableSearch
      columns={REGISTRATION_EXPIRY_SEARCH_COLUMNS(onVehicleClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={
        searchResults.pagination || initialDataWithPagination.pagination
      }
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
    />
  );
};

export default memo(RegistrationSearchResults);
